import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Header from '../Header';
import { getMyContract, getManagedContracts } from '../../api/contracts';
import api from '../../api/axios';

const ContractsIndex = () => {
    const nav = useNavigate();

    const [authUser, setAuthUser] = useState(null);
    const [myContract, setMyContract] = useState(null);

    const [team, setTeam] = useState([]);
    const [teamMeta, setTeamMeta] = useState(null);
    const [loadingTeam, setLoadingTeam] = useState(false);
    const [q, setQ] = useState('');

    useEffect(() => {
        (async () => {
            try {
                const { data } = await api.get('/api/user');
                setAuthUser(data);
            } catch {}
        })();
    }, []);

    useEffect(() => {
        (async () => {
            try {
                const mine = await getMyContract();
                setMyContract(mine);
            } catch {}
        })();
    }, []);

    const loadManaged = async (params = {}) => {
        setLoadingTeam(true);
        try {
            const res = await getManagedContracts({ cycle_id: 'active', q, ...params });
            setTeam(res?.data || []);
            setTeamMeta(res?.meta || null);
        } finally {
            setLoadingTeam(false);
        }
    };

    useEffect(() => { loadManaged(); }, []);    // initial
    useEffect(() => { const t = setTimeout(() => loadManaged(), 300); return () => clearTimeout(t); }, [q]); // debounced search

    return (
        <>
            <Header label={<p className="py-0 my-0">Contracts</p>} />
            <main id="main" className="main">
                <div className="row">
                    <div className="col-lg-12">

                        {/* My Contract */}
                        {/*<div className="card mb-4">
                            <div className="card-header d-flex justify-content-between align-items-center">
                                <h6 className="mb-0">My Contract (Active Cycle)</h6>
                                <button
                                    className="btn btn-primary btn-sm"
                                    onClick={() => nav('/contracts/mine')}
                                >
                                    Open My Contract
                                </button>
                            </div>
                            <div className="card-body">
                                {myContract ? (
                                    <div className="d-flex flex-wrap gap-4">
                                        <div><span className="text-muted">Status:&nbsp;</span>
                                            <span className={`badge ${myContract?.status?.name === 'Complete' ? 'bg-success' : 'bg-secondary'}`}>
                        {myContract?.status?.name ?? '—'}
                      </span>
                                        </div>
                                        <div><span className="text-muted">Employee Approved:&nbsp;</span>
                                            {myContract.user_approved_at ? <span className="badge bg-success">Yes</span> : <span className="badge bg-secondary">No</span>}
                                        </div>
                                        <div><span className="text-muted">Manager Approved:&nbsp;</span>
                                            {myContract.manager_approved_at ? <span className="badge bg-success">Yes</span> : <span className="badge bg-secondary">No</span>}
                                        </div>
                                    </div>
                                ) : (
                                    <div className="text-muted">Loading…</div>
                                )}
                            </div>
                        </div>*/}

                        {/* Team */}
                        <div className="card">
                            <div className="card-header d-flex justify-content-between align-items-center">
                                <h5 className="mb-0">My Team’s Contracts (Current Cycle)</h5>
                                <input
                                    className="form-control form-control-sm"
                                    style={{ width: 260 }}
                                    placeholder="Search by name or email…"
                                    value={q}
                                    onChange={e => setQ(e.target.value)}
                                />
                            </div>
                            <div className="card-body">
                                <div className="table-responsive reviews-table">
                                    <table className="table table-sm table-hover mb-0 align-middle">
                                        <thead className="table-light">
                                        <tr>
                                            <th style={{width: 32}}>#</th>
                                            <th>Employee</th>
                                            <th>Email</th>
                                            <th style={{width: 140}}>Status</th>
                                            <th style={{width: 160}} className="text-center">Employee Approved</th>
                                            <th style={{width: 160}} className="text-center">Manager Approved</th>
                                            <th style={{width: 120}} className="text-end">Actions</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {loadingTeam && (
                                            <tr><td colSpan="7" className="text-center text-muted py-4">Loading…</td></tr>
                                        )}
                                        {!loadingTeam && team?.length === 0 && (
                                            <tr><td colSpan="7" className="text-center text-muted py-4">No direct reports or no contracts found.</td></tr>
                                        )}
                                        {team?.map((c, idx) => (
                                            <tr key={c.id}>
                                                <td>{idx + 1}</td>
                                                <td className="fw-semibold">{c.user?.name}</td>
                                                <td className="text-muted">{c.user?.email}</td>
                                                <td>
                            <span className={`badge ${c?.status?.name === 'Complete' ? 'bg-success' : 'bg-secondary'}`}>
                              {c?.status?.name ?? '—'}
                            </span>
                                                </td>
                                                <td className="text-center">
                                                    {c.user_approved_at ? <span className="badge bg-success">Yes</span> : <span className="badge bg-secondary">No</span>}
                                                </td>
                                                <td className="text-center">
                                                    {c.manager_approved_at ? <span className="badge bg-success">Yes</span> : <span className="badge bg-secondary">No</span>}
                                                </td>
                                                <td className="text-end">
                                                    <button
                                                        className="btn btn-outline-primary btn-sm"
                                                        onClick={() => nav(`/contracts/${c.id}`)}
                                                    >
                                                        Open
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            {/* optionally render pagination using teamMeta */}
                        </div>

                    </div>
                </div>
            </main>
        </>
    );
};

export default ContractsIndex;
